(function($){
    $(document).ready(function(){
        var int = setInterval(function(){
            if($('.ui-datepicker-month').length > 0){
                $('.ui-datepicker-month option').each(function(){
                    if($(this).html() == 'lt.'){
                        $(this).html('luty')
                    }
                    if($(this).html() == 'wrz.'){
                        $(this).html('wrzesień')
                    }
                    if($(this).html() == 'Maj'){
                        $(this).html('maj')
                    }
                })
                // clearInterval(int);
            }
        }, 500);
        // $('.hasDatepicker').attr('readonly', 'readonly');
    })
})(jQuery);